import { style } from '@react-spectrum/s2/style' with { type: 'macro' };
import { memo, useCallback } from 'react';

import { useOptimisticState } from '@/hooks/useOptimisticState';

import type { IGCommentWatcherClassContent } from '../../../../bridge/types/artifact.ts';

import {
	CollapsiblePrompt,
	MutedLabel,
} from './comment-watcher/CollapsiblePrompt';
import type { ArtifactComponentProps } from './types';

type DmReplyProps = ArtifactComponentProps<IGCommentWatcherClassContent>;

const exampleBubbleBackground = style({
	backgroundColor: 'informative-200',
});

export const DmReply = memo(function DmReply({
	content,
	isReadOnly = false,
	onContentChange,
}: DmReplyProps) {
	const [promptValue, setPromptValue] = useOptimisticState(
		content.dm_prompt ?? '',
	);

	const handlePromptCommit = useCallback(
		(value: string) => onContentChange?.({ dm_prompt: value }),
		[onContentChange],
	);

	return (
		<div className="flex flex-col gap-2.5">
			<div>
				<MutedLabel>Prompt</MutedLabel>
				<div className="mt-1">
					<CollapsiblePrompt
						value={promptValue}
						isReadOnly={isReadOnly}
						onChange={setPromptValue}
						onCommit={(value) => {
							if (value !== (content.dm_prompt ?? '')) {
								handlePromptCommit(value);
							}
						}}
					/>
				</div>
			</div>

			{content.example_dm && (
				<div className="py-1">
					<MutedLabel>Example DM</MutedLabel>
					<div className="mt-1.5 flex justify-end">
						<div
							className={`${exampleBubbleBackground} inline-block max-w-[90%]
							rounded-[16px_16px_4px_16px] px-3 py-1.5`}
						>
							<p className="m-0 text-xs leading-[1.45] text-(--text-secondary)">
								{content.example_dm}
							</p>
						</div>
					</div>
				</div>
			)}
		</div>
	);
});
